// extracted by mini-css-extract-plugin
export default {"container":"touristDocument-module__container__JQjNN","fields":"touristDocument-module__fields__fp7CM","button":"touristDocument-module__button__zyK+r"};